import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileFolderColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 10L12.2875 6.28751C12.1955 6.19591 12.0862 6.12338 11.9661 6.07404C11.846 6.02471 11.7174 5.99955 11.5875 6.00001H5C4.7348 6.00001 4.4804 6.10536 4.2929 6.2929C4.1054 6.48044 4 6.73479 4 7.00001V25.075C4 25.1965 4.0239 25.3168 4.0704 25.429C4.1169 25.5412 4.185 25.6432 4.2709 25.7291C4.3568 25.815 4.4588 25.8831 4.571 25.9296C4.6832 25.9761 4.8035 26 4.925 26H27.1125C27.3479 26 27.5736 25.9065 27.7401 25.7401C27.9065 25.5736 28 25.3479 28 25.1125V11C28 10.7348 27.8946 10.4804 27.7071 10.2929C27.5196 10.1054 27.2652 10 27 10H16Z",
		fill: "#FBE9B1"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.3461 5.14907C12.1043 5.04975 11.8454 4.99911 11.584 5.00001H5C4.46955 5.00001 3.96076 5.21076 3.58572 5.58588C3.21073 5.96095 3 6.46963 3 7.00001V25.075C3 25.3279 3.04978 25.5783 3.14659 25.8119C3.24335 26.0453 3.38508 26.2575 3.56379 26.4362C3.74251 26.6149 3.95468 26.7567 4.18814 26.8534C4.42173 26.9502 4.67213 27 4.925 27H27.1125C27.613 27 28.093 26.8012 28.447 26.4474C28.8012 26.093 29 25.613 29 25.1125V11C29 10.4696 28.7892 9.96084 28.4142 9.58579C28.0392 9.21075 27.5304 9 27 9H16.4142L12.9946 5.58042C12.8078 5.39445 12.5879 5.2484 12.3461 5.14907ZM15.9939 11C15.998 11 16.002 11 16.0061 11H27V25H5V11H15.9939ZM13.5854 9L11.585 7.00001H5V9H13.5854Z",
		fill: "#B78200"
	})]
});
export default SvgFileFolderColored;
